import { connect } from 'react-redux';
import populateChannels from 'store/selectors/populateChannels';

const mapStateToProps = state => ({
  chats: Object.values(populateChannels(state)).filter(c => c.isDirect || c.isMember),
});

export default connect(mapStateToProps);
